export const APPOINTMENT_TYPES = [
  { key: "pickup", label: "Freight Pickup" },
  { key: "delivery", label: "Delivery Window" },
  { key: "consultation", label: "Business Consultation" },
  { key: "interview", label: "Job Interview" },
];

export const APPOINTMENT_TYPE_LABELS = Object.fromEntries(APPOINTMENT_TYPES.map((t) => [t.key, t.label]));

export const TIME_SLOTS = [
  { key: "07:00", label: "7:00 AM" },
  { key: "08:00", label: "8:00 AM" },
  { key: "09:00", label: "9:00 AM" },
  { key: "10:00", label: "10:00 AM" },
  { key: "11:00", label: "11:00 AM" },
  { key: "12:00", label: "12:00 PM" },
  { key: "13:00", label: "1:00 PM" },
  { key: "14:00", label: "2:00 PM" },
  { key: "15:00", label: "3:00 PM" },
  { key: "16:00", label: "4:00 PM" },
  { key: "17:00", label: "5:00 PM" },
];

export const TIME_SLOT_LABELS = Object.fromEntries(TIME_SLOTS.map((s) => [s.key, s.label]));

export const APPOINTMENT_STATUSES = ["scheduled", "completed", "cancelled"];

export const toDateStr = (d) => d.toLocaleDateString("en-CA");
